
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { FilterTypesEnum } from "./FilterTypesEnum";
import classes from './FilterContentBank.module.css'
import { onKeyDown } from "../../../../service";

const FilterContentBank = ({ type, text, handleChange, list, filterKey, hideClear, selected }) => {
    const direction = useSelector(state => state.translate.direction);
    const texts = useSelector(state => state.translate.texts);
    const [currentBtn, setCurrentBtn] = useState(null)
    function changeBtn(item) {
        setCurrentBtn(item)
        handleChange && handleChange(item, filterKey)
    }

    var timer = 0;
    const handleChangeFilter = (e) => {
        clearTimeout(timer);
        timer = setTimeout(() => handleChange(e.target.value, filterKey), 700);
    }

    useEffect(() => {
        if (hideClear && selected) {
            setCurrentBtn(selected)
        }
    }, [hideClear, selected])

    switch (type) {
        case FilterTypesEnum.free:
            return (
                <div className={classes.WrapInput}>
                    <div className={classes.InputAndIcon}>
                        <input type='text' placeholder={text} className={classes.Input} onKeyUp={handleChangeFilter} onKeyDown={() => clearTimeout(timer)} ></input>
                        <div className={classes.FilterIcon}></div>
                    </div>
                </div>
            )

        case FilterTypesEnum.select:
            return (
                <div className={`${classes[direction]} ${classes.WrapInput}`}>
                    <label className={classes.Label}>{text}</label>
                    <select className={classes.Select} onChange={(e) => handleChange(e.target.value, filterKey)} >
                        <option value={""}>{texts.all}</option>
                        {list && list.map(item => <option key={item}>{item}</option>)}
                    </select>
                </div>
            )

        case FilterTypesEnum.buttons:
            return (
                <div className={classes.ButtonsContainer}>
                    <div className={classes.TextContainer}>
                        <div className={classes.Label}>{text}</div>
                        {hideClear ? '' : <div className={classes.Clear} onClick={() => changeBtn(null)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => changeBtn(null))}>{texts.clear}</div>}
                    </div>
                    <div className={classes.ButtonsWarrper}>
                        {list && list.map(item =>
                            <div className={`${classes.Button}  ${currentBtn == item.value ? classes.SelectedButton : ''}`} key={item.value} onClick={() => changeBtn(item.value)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => changeBtn(item.value))}>{item.text}</div>
                        )}
                    </div>
                </div>
            )

        case FilterTypesEnum.tags:
            return (
                <div className={classes.TagsContainer}>
                    <div className={classes.TextContainer}>
                        <div className={classes.Label}>{text}</div>
                        <div className={classes.Clear} onClick={() => changeBtn(null)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => changeBtn(null))}>{texts.clear}</div>
                    </div>
                    <div className={classes.TagsWarrper}>
                        {list && list.map(item =>
                            <div className={`${classes.Tag}  ${currentBtn == item ? classes.SelectedTag : ''}`} key={item} onClick={() => changeBtn(item.value)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => changeBtn(item.value))}>{item}</div>
                        )}
                    </div>
                </div>
            )
        default:
            return null
    }
}

export default FilterContentBank;